export default "__VITE_ASSET__DG_umoE5__"